import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-skeleton",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 1,
  class: "ui-spinner-wrap"
}
const _hoisted_3 = {
  key: 0,
  class: "ui-loader-label"
}
const _hoisted_4 = { class: "visually-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui-loader", [`ui-loader-${_ctx.mode}`, { 'ui-loader-compact': _ctx.size === 'sm' }]]),
    role: "status",
    "aria-live": "polite",
    "aria-busy": true
  }, [
    (_ctx.variant === 'skeleton')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "ui-skeleton-head" }, [
            _createElementVNode("span", { class: "ui-skel ui-skel-title" }),
            _createElementVNode("span", { class: "ui-skel ui-skel-chip" })
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (n) => {
            return (_openBlock(), _createElementBlock("div", {
              key: n,
              class: "ui-skeleton-row"
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ui-skel ui-skel-avatar" }, null, -1)),
              _createElementVNode("span", {
                class: "ui-skel ui-skel-line",
                style: _normalizeStyle({ width: 30 + ((n * 17) % 40) + '%' })
              }, null, 4),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ui-skel ui-skel-line ui-skel-short" }, null, -1)),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ui-skel ui-skel-pill" }, null, -1))
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("span", {
            class: "ui-spinner",
            "aria-hidden": "true"
          }, [
            _createElementVNode("span", { class: "ui-spinner-ring" }),
            _createElementVNode("span", { class: "ui-spinner-core" })
          ], -1)),
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.label || "Chargement…"), 1)
  ], 2))
}